import { FC, ReactNode } from "react";
import "./Divider.scss";

export type DividerProps = {
  /**
   * label text to show in the center of the divider
   */
  label?: ReactNode;
  /**
   * className to apply to the divider
   */
  className?: string;
};

const Divider: FC<DividerProps> = function (props) {
  const { label, className } = props;
  return (
    <div className={`divider ${className}`}>
      <div className="line" />
      {label && <div className="divider__label">{label}</div>}
      <div className="line" />
    </div>
  );
};

export default Divider;

Divider.defaultProps = {
  label: undefined,
  className: "",
};
